import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import "../styles/Blog.css";

// Import all blog post JSON files from the posts folder
const postsContext = require.context("../content/posts", false, /\.json$/);
const allPosts = postsContext.keys().map((key) => postsContext(key));

const _imagesContext = require.context(
  "../assets",
  false,
  /\.(png|jpe?g|webp|svg)$/
);
const _images = _imagesContext.keys().reduce((acc, p) => {
  const key = p.replace("./", "");
  acc[key] = _imagesContext(p);
  return acc;
}, {});

function resolveImage(path) {
  if (!path) return null;
  const m = path.match(/assets\/(.+)$/);
  const name = m ? m[1] : null;
  if (name && _images[name]) return _images[name];
  return path.replace(/^\.\./, "");
}

export default function Post() {
  const { id } = useParams();
  const [post, setPost] = useState(null);

  useEffect(() => {
    const found = allPosts.find((p) => p.id === id);
    setPost(found || null);
  }, [id]);

  useEffect(() => {
    if (post) {
      document.title = `${post.title} — Vortex`;
    } else {
      document.title = `Objava ni najdena — Vortex`;
    }
  }, [post]);

  if (!post) {
    return (
      <div className="blog-container">
        <div className="post-not-found">
          <h2>Objava ni najdena</h2>
          <p>Žal objava s tem ID-jem ne obstaja ali je bila premaknjena.</p>
          <Link className="button" to="/blog">
            Nazaj na blog
          </Link>
        </div>
      </div>
    );
  }

  const imageSrc = resolveImage(post.image);

  return (
    <div className="blog-container">
      <article className="single-post">
        {imageSrc && (
          <div className="single-post-image">
            <img src={imageSrc} alt={post.title} />
          </div>
        )}
        <h1 className="single-post-title">{post.title}</h1>
        <div className="post-meta">
          {post.date} • {post.author}
        </div>
        <div
          className="single-post-content"
          dangerouslySetInnerHTML={{ __html: post.content }}
        />
        <div style={{ marginTop: 24 }}>
          <Link className="button" to="/blog">
            Nazaj na blog
          </Link>
        </div>
      </article>
    </div>
  );
}
